let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Y7rXC")).then(() => parcelRequire('1YfCq'));